import urls from '@/networkRequests/apiClient/endpoints'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getAllFulfillmentOrdersForAdminApi } from './getAllFulfillmentOrdersForAdmin.api'
import getAllFulfillmentOrdersForAdminInitialState from './getAllFulfillmentOrdersForAdmin.initialState'
import {
  GetAllFulfillmentOrdersForAdminErrorResponse,
  GetAllFulfillmentOrdersForAdminRequestPayload
} from './getAllFulfillmentOrdersForAdmin.types'

export const getAllFulfillmentOrdersForAdmin = createAsyncThunk(
  urls.admin.getAllFulfillmentOrdersForAdmin,
  async (payload: GetAllFulfillmentOrdersForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getAllFulfillmentOrdersForAdminApi(request)

      if (onSuccess) {
        onSuccess()
      }

      return response
    } catch (error) {
      return rejectWithValue(error as ApiErrorResponse)
    }
  }
)

const getAllFulfillmentOrdersForAdminSlice = createSlice({
  name: 'getAllFulfillmentOrdersForAdmin',
  initialState: getAllFulfillmentOrdersForAdminInitialState,
  reducers: {
    resetGetAllFulfillmentOrdersForAdmin: () => getAllFulfillmentOrdersForAdminInitialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllFulfillmentOrdersForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAllFulfillmentOrdersForAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(getAllFulfillmentOrdersForAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as GetAllFulfillmentOrdersForAdminErrorResponse
        errorHandler.handleApiError(action.payload as GetAllFulfillmentOrdersForAdminErrorResponse, undefined, true)
      })
  }
})

export const getAllFulfillmentOrdersForAdminActions = {
  ...getAllFulfillmentOrdersForAdminSlice.actions,
  getAllFulfillmentOrdersForAdmin
}

export default getAllFulfillmentOrdersForAdminSlice.reducer
